import { fetch } from "../services/api";
import useApi from "./useApi";
// import { HotelsByCode, getHotel } from '../graphql/queries';
// import { createWebPushNotification, updateWebPushNotification } from '../graphql/mutations';


const useHotelActions = () => {
    const { get } = useApi();

    const getHotelByCode = async (clientCode) => {
        try {
          const response = await get(`hotels/?code=${clientCode}`);
          return response || false;
        } catch (error) {
          console.error('Error fetching hotel by code:', error);
          return false;
        }
    };

    // const getHotelByCode = (clientCode) => {
    //     return get(`hotels/?code=${clientCode}`)
    //         .then(r => r || false)
    //     // return fetch(HotelsByCode, {
    //     //     code: clientCode
    //     // }).then(r => {
    //     //     if (r.data.HotelsByCode.items) {
    //     //         if (r.data.HotelsByCode.items.length === 1) {
    //     //             return r.data.HotelsByCode.items[0];
    //     //         }
    //     //     }
    //     //     return false;
    //     // })
    // }

    const getHotelById = async (id) => {
        try {
            const response = await get(`hotels/?id=${id}`);
            return response || false;
        } catch (error) {
            console.error('Error fetching hotel by id:', error);
            return false;
        }
    };

    const registerWebPush = (hotelId, actualPushId, agent, webPushData) => {
        console.log('TODO - registerWebPush')
        // const action = actualPushId ? updateWebPushNotification : createWebPushNotification;
        // const WebPushRecord = {
        //     hotelId: hotelId,
        //     os: JSON.stringify(agent.os),
        //     device: JSON.stringify(agent.device),
        //     data: JSON.stringify(webPushData)
        // };
        // if (actualPushId) {
        //     WebPushRecord['id'] = actualPushId;
        // }
        // console.log('regSW WebPushRecord', WebPushRecord)
        // return fetch(action, { input: WebPushRecord})
        //     .then(r => {
        //         if (r.data?.createWebPushNotification?.id) {
        //             return r.data.createWebPushNotification.id;
        //         }
        //         if (r.data?.updateWebPushNotification?.id) {
        //             return r.data.updateWebPushNotification.id;
        //         }
        //         throw new Error('hotel-addWebPush-error')
        //     }).catch((response) => {
        //         console.log('error', response)
        //         throw new Error('hotel-addWebPush-error')
        //     });
    }

    return {
        getHotelByCode,
        getHotelById,
        registerWebPush
    }

}

export default useHotelActions;